import { Link } from "react-router-dom";
import { movies } from "@/mocks/movies";

const ranking = [...movies].sort((a, b) => b.rating - a.rating).slice(0, 5);

export default function PopularRanking() {
  return (
    <section className="w-full px-4 md:px-6 py-12 md:py-16 bg-background-100 border-t border-background-300/60">
      <div className="w-full max-w-[1400px] mx-auto grid grid-cols-1 lg:grid-cols-[1.1fr_0.9fr] gap-8 lg:gap-12">
        <div className="min-w-0">
          <p className="font-label text-[11px] tracking-[0.26em] uppercase text-accent-500">
            About the Archive
          </p>
          <h2 className="mt-2 font-heading text-2xl md:text-3xl text-foreground-950">
            一个认真整理的日韩影视资料站
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600">
            日韩黄色电影并不做资源分发。我们做的事情更接近一座小型资料馆：为每一部作品建立条目，
            记录导演、演员、片长、题材与创作背景，并按照年代与主题整理成可检索的片单。
          </p>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600">
            如果你正在寻找某一类情绪、某一种叙事节奏，或只是想认识这个类型里被讨论最多的名字，
            可以从分类页开始，用筛选器把范围收窄。
          </p>

          <div className="mt-7 grid grid-cols-2 sm:grid-cols-3 gap-3">
            {[
              { value: "20", label: "收录影片", unit: "部" },
              { value: "8", label: "影视资讯", unit: "篇" },
              { value: "6", label: "分类专题", unit: "个" },
            ].map((stat) => (
              <div
                key={stat.label}
                className="p-4 rounded-lg bg-background-50 border border-background-300/60"
              >
                <p className="font-heading text-2xl md:text-3xl text-accent-500">
                  {stat.value}
                  <span className="ml-1 text-xs text-foreground-500">{stat.unit}</span>
                </p>
                <p className="mt-1.5 text-[11px] text-foreground-500 tracking-wider">
                  {stat.label}
                </p>
              </div>
            ))}
          </div>

          <Link
            to="/about"
            className="mt-7 inline-flex items-center gap-2 text-sm text-foreground-700 hover:text-accent-500 transition-colors cursor-pointer"
          >
            了解站点定位与内容规范
            <i className="ri-arrow-right-line" />
          </Link>
        </div>

        <div className="min-w-0">
          <div className="flex items-center justify-between">
            <h3 className="font-heading text-lg text-foreground-950 flex items-center gap-2">
              <i className="ri-fire-line text-accent-500" />
              站内口碑排行
            </h3>
            <Link
              to="/category/popular"
              className="text-xs text-foreground-500 hover:text-accent-500 transition-colors cursor-pointer whitespace-nowrap"
            >
              完整榜单
            </Link>
          </div>

          <ul className="mt-4 rounded-lg border border-background-300/60 bg-background-50 overflow-hidden">
            {ranking.map((movie, index) => (
              <li key={movie.id} className="border-b border-background-300/50 last:border-b-0">
                <Link
                  to={`/detail/${movie.id}`}
                  className="group flex items-center gap-3 md:gap-4 px-3.5 md:px-4 py-3 hover:bg-background-100 transition-colors cursor-pointer"
                >
                  <span
                    className={`w-7 font-heading text-lg text-center shrink-0 ${
                      index < 3 ? "text-accent-500" : "text-foreground-400"
                    }`}
                  >
                    {String(index + 1).padStart(2, "0")}
                  </span>
                  <div className="w-11 h-16 rounded-md overflow-hidden bg-background-200 shrink-0">
                    <img
                      src={movie.cover}
                      alt={`${movie.title} 封面`}
                      title={movie.title}
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                  <div className="min-w-0 flex-1">
                    <p className="text-sm text-foreground-900 group-hover:text-accent-500 transition-colors truncate">
                      {movie.title}
                    </p>
                    <p className="mt-1 text-[11px] text-foreground-500 truncate">
                      {movie.year} · {movie.region} · {movie.genres[0]}
                    </p>
                  </div>
                  <span className="flex items-center gap-1 text-xs text-foreground-600 shrink-0">
                    <i className="ri-star-fill text-[10px] text-accent-500" />
                    {movie.rating.toFixed(1)}
                  </span>
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}